import './index.scss';
import React from 'react';
import Breadcrumbs from 'components/breadcrumb';
import Layout from '_metronic/layout/Layout';

import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';
import { PorletHeaderTitle } from 'components/porletHeader';
import Typography from '@material-ui/core/Typography';

const breadcrumb = [
  { page: 'distributor/building', title: 'Arquitectura' },
  { page: 'distributor/building', title: 'Proyectos registrados' },
];

export default () => (
  <Layout>
    <div className="kt-space-20" />
    <div className="row">
      <div className="col-12">
        <div className="kt-space-20" />
        <Breadcrumbs title="Arquitectura" items={breadcrumb} />

        <div className="kt-space-20" />
      </div>
    </div>
    <div className="row thankyou">
      <div className="col-sm-12 col-md-12 col-lg-2" />
      <div className="col-sm-12 col-md-12 col-lg-8">
        <PorletHeaderTitle variant="h4">
          <FormattedMessage id="¡Listo!" />
        </PorletHeaderTitle>
        <Typography variant="h4" color="secondary">
          <FormattedMessage id="El proyecto ha sido ingresado con éxito." />
        </Typography>
        <Typography variant="h6">
          <FormattedMessage id="La garantía está siendo aprobada." />
        </Typography>
        <Typography variant="h6">
          <FormattedMessage id="Cuando esté disponible, serás notificado por email." />
        </Typography>
        <Typography variant="h6">
          <FormattedMessage id="Encontrarás el certificado en" />{' '}
          <Link to="/installer/building">
            <FormattedMessage id="Mis proyectos" />
          </Link>
        </Typography>
        <div className="kt-space-20" />
        <Link to="/installer/building">
          <Button variant="contained" color="primary" size="large">
            <FormattedMessage id="Finalizar" />
          </Button>
        </Link>
      </div>
      <div className="col-sm-12 col-md-12 col-lg-2" />
    </div>
    <div className="kt-space-20" />
  </Layout>
);
